import createAPI from '../request'

const featureFlagServiceAPI = {
  getIsFeatureFlagEnabled: (url, params) => createAPI(url, 'get', params),
};
export default featureFlagServiceAPI;
